
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import FormWrapper from "@/components/FormWrapper.vue";
import Evrak from "@/classes/evrak/Evrak";
import {TakipEntity} from "@/entity/TakipEntity";
import KapakHesabi from "@/classes/evrak/KapakHesabi/KapakHesabi";
import KapakHesabiCalculator from "@/classes/evrak/KapakHesabi/KapakHesabiCalculator";
import TakipTalebiGenerator from "@/classes/evrak/TakipTalebi/TakipTalebiGenerator";
import {AlacakKalemiAlani} from "@/enum/AlacakKalemiAlani";
import HesapTablosuInfo from "@/components/infos/HesapTablosuInfo.vue";

@Component({
  components: {HesapTablosuInfo, FormWrapper}
})
export default class TakipHarcVarTaslak extends Vue {
  @Prop() takip!: TakipEntity;
  @Prop() hesapTarihi!: Date
  @Prop () dovizTahsilat!:number

  AlacakKalemiAlani = AlacakKalemiAlani;
  kapakHesabi: KapakHesabi = new KapakHesabi();
  ttEvrak: Evrak = new Evrak();

  mounted() {
    if (this.takip) {
      this.onTakipChange();
      this.calculateKapakHesabi()
    }
  }
  get faiz2Tutarlari() {
    const faiz2Tutarlari: any[] = [];

    if (this.kapakHesabi.paraBirimleri) {
      this.kapakHesabi.paraBirimleri.forEach((paraBirimi: any) => {
        const tutar = this.kapakHesabi.getTakipSonrasiAlacakKalemi(
            this.AlacakKalemiAlani.takipSonrasiFaiz,
            paraBirimi.id
        );
        const formatliTutar = this.$helper.tutarStr(tutar, paraBirimi);
        faiz2Tutarlari.push(formatliTutar);
      });
    }
    return faiz2Tutarlari;
  }
  calculateKapakHesabi() {
    if (this.takip.id) {
      let kapakHesabiCalculator: KapakHesabiCalculator = new KapakHesabiCalculator();
      kapakHesabiCalculator.setTakip(this.takip);
      this.kapakHesabi = kapakHesabiCalculator.calculateKapakHesabi();
      this.kapakHesabi.alacakKalemiAlanlari.sort(function (a, b) {
        return a - b;
      });
      this.kapakHesabi.takipSonrasialacakKalemiAlanlari.sort(function (a, b) {
        return a - b;
      });
    }
  }

  @Watch("takip")
  onTakipChange() {
    let takipTalebiGenerator = new TakipTalebiGenerator()
    takipTalebiGenerator.setTakip(this.takip);
    this.ttEvrak = takipTalebiGenerator.getTakipTalebiEvrak();
    this.calculateKapakHesabi()
  }

  print() {
    this.$helper.printComponent('takipHarcVarTaslak');
  }


}
